/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import mainTime from './abc/mainTime'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(Observer)
gsap.registerPlugin(ScrollToPlugin)

let tweening = true // now this is in the global scope
let wasReloaded = false

// reset everything on refresh
$(window).on('beforeunload', () => {
  if (wasReloaded) {
    $(window).scrollTop(0)
  }
})

ScrollTrigger.clearScrollMemory()
window.history.scrollRestoration = 'manual'

const handleResize = () => {
  wasReloaded = true
  window.location.reload()
}

let debounceTimeout
// fix scroll positioning on resize
$(window).on('resize', () => {
  tweening = true
  clearTimeout(debounceTimeout)
  debounceTimeout = setTimeout(handleResize, 250)
})

// gsap.utils.toArray('.floatMe').forEach(brownianFloat)

// Do the fade in once
mainTime.seek('start')
mainTime.tweenTo(
  'introduction',
  {
    onComplete: () => {
      tweening = false
    },
  },
)

// Capture scroll on everything
let scrolling = false // setting and unsetting this to avoid false scrolling on high velocity things

const swapLabelColor = () => {
  const currentLabel = mainTime.currentLabel()
  const chapterLabel = $('.chapterLabel')
  if (currentLabel === 'eyeball' || currentLabel === 'injectedEyeball') {
    chapterLabel.addClass('chapterLabel_dark')
  } else {
    chapterLabel.removeClass('chapterLabel_dark')
  }
}

const nextStop = () => {
  if (!tweening && !scrolling && mainTime.currentLabel() !== 'conclusion') {
    // console.log(`Tweening DOWN to ${mainTime.nextLabel()}`)
    tweening = true
    mainTime.tweenTo(
      mainTime.nextLabel(),
      {
        onComplete: () => {
          // console.log('Done tweening DOWN')
          tweening = false
          swapLabelColor()
        },
      },
    )
  }
}

const prevStop = () => {
  if (!tweening && !scrolling && mainTime.previousLabel() !== 'start') {
    // console.log(`Seeking UP to ${mainTime.previousLabel()}`)
    tweening = true
    mainTime.timeScale(3) // make it faster
    mainTime.tweenTo(
      mainTime.previousLabel(),
      {
        onComplete: () => {
          mainTime.timeScale(1) // set it back to default speed
          tweening = false
          swapLabelColor()
        },
      },
    )
  }
}

const isMobileWidth = !!(Math.min(window.screen.width, window.screen.height) < 768)

// We're using the "Main" timeline here to divide things up in an easier format
Observer.create({
  id: 'main',
  type: 'wheel,touch,scroll',
  tolerance: 15,
  preventDefault: true,
  onDown: () => (
    isMobileWidth ? prevStop() : nextStop()
  ),
  onUp: () => (
    isMobileWidth ? nextStop() : prevStop()
  ),
  // these two callbacks refine things by basically keeping us from scrolling too far easily
  onChangeY: () => {
    if (!scrolling) {
      // console.log('scrolling')
      scrolling = true

      // hacky fallback to unlock scrolling if someone scrolls like Amanda :)
      setTimeout(() => {
        if (scrolling) {
          scrolling = false
        }
      }, 2000) // 2 seconds ought to be enough?
    }
    swapLabelColor()
  },
  onStop: () => {
    // console.log('stopped scrolling')
    scrolling = false
  },
  onStopDelay: 0.1,
})

Observer.create({
  id: 'progress-wrapper',
  type: 'wheel, touch, pointer',
  onClick: () => {
    swapLabelColor()
  },
})

// Ya can't stop progress!  Here's the progress bar stuff.

// This is an array of labels that, if they exist, will be special stops that appear bold and
// have hover labels on them in the UI. Note that if you want to add to this list the key MUST
// match the label on the timeline. Duh.
const chapters = [
  {
    title: 'Introduction',
    label: 'introduction',
  },
  {
    title: 'The ABC Platform',
    label: 'platform',
  },
  {
    title: 'Nature\'s Zwitterion',
    label: 'zwitterion',
  },
  {
    title: 'Structured, Macromolecular Water',
    label: 'structured-water',
  },
  {
    title: 'Unique Properties in the Eye',
    label: 'eyeball',
  },
  {
    title: 'Non-Adsorptive',
    label: 'non-adsorptive',
  },
  {
    title: 'Frictionless',
    label: 'frictionless',
  },
  {
    title: 'Stereospecific Docking',
    label: 'bound',
  },
  {
    title: 'Fast Systemic Clearance',
    label: 'clearanceIntro',
  },
  {
    title: 'Conclusion',
    label: 'conclusion',
  },
]

const stops = mainTime.labels
const totalTime = mainTime.totalDuration()
let labelsLeft = false
for (const [stop, time] of Object.entries(stops)) {
  const stopPct = (time / totalTime) * 100

  // see if this is a special chapter
  const thisChapter = chapters.filter((chapter) => chapter.label === stop)
  const chapterMaybe = thisChapter.length > 0 ? `<div class="chapterLabel">${thisChapter[0].title}</div>` : ''
  if (thisChapter[0]?.label === 'structured-water') { // switch labels from left to right here
    labelsLeft = true
  }
  const labelClass = labelsLeft ? ' labelLeft' : ''
  const chapStopClass = thisChapter.length > 0 ? ' chapStop' : ''
  $('#progress-wrapper').append(`<a data-section="${stop}" style="left: ${stopPct}%" class="stop${labelClass}${chapStopClass}"><span></span>${chapterMaybe}</a>`)
}

$(window).on('load', () => {
  $('#progress-wrapper').on('click', '.stop', (e) => {
    e.preventDefault()
    tweening = true
    const sectionSlug = $(e.currentTarget).attr('data-section')
    mainTime.seek(sectionSlug)
    setTimeout(() => {
      gsap.to('#progress-indicator', { width: `${mainTime.progress() * 100}%` })
      tweening = false
    }, 20)
  })
})

// keyboard nav
document.onkeydown = (e) => {
  if (e.code === 'ArrowDown' || e.code === 'ArrowRight') {
    e.preventDefault()
    nextStop()
  } else if (e.code === 'ArrowUp' || e.code === 'ArrowLeft') {
    e.preventDefault()
    prevStop()
  } else if (e.code === 'Space') {
    e.preventDefault()
    nextStop()
  }
}

$('.scrollButton button').on('click', (e) => {
  e.preventDefault()
  nextStop()
})

// media queries
const mm = gsap.matchMedia()

mm.add('(min-width: 1280px)', () => {
  gsap.to(
    '#eyeball-container',
    {
      width: '45%',
    },
  )
})

mm.add('(max-width: 1279.99px', () => {
  gsap.to(
    '#eyeball-container',
    {
      width: '50%',
    },
  )
})

mm.add('(max-width: 970px)', () => {
  gsap.to(
    '#eyeball-container',
    {
      // width: '60%',
      paddingBottom: '100%',
    },
  )
})

// Changes left of #floating-strawberry-1 when it first appears and not the
// second time .to is called on it
mm.add({
  isMobile: '(max-width: 767px)',
  isDesktop: '(min-width: 768px',
}, (context) => {
  // console.log(context.conditions)
  const { isMobile, isDesktop } = context.conditions
  const currentLabel = mainTime.currentLabel()
  if (currentLabel === 'bound') {
    // console.log('at bound label, scooch the strawberry')
    gsap.set(
      '#floating-strawberry-1', // changes left value at wrong part of timeline
      {
        left: isMobile ? '20%' : '50%',
      },
      '-=0.4',
    )
  }
})
